@if (!loading()) {
	<div class="fade-in container">
		<div class="list-container">
			<div class="search-wrapper fade-in">
				<app-search-form (onSubmit)="onSearchFormSubmit$($event)"></app-search-form>
			</div>

			<div class="pagination-wrapper fade-in">
				<nz-pagination
					[nzPageIndex]="1"
					[nzPageSize]="COGNITO_USER_PAGE_SIZE"
					[nzTotal]="totalUsers()"
					(nzPageIndexChange)="onPageChange($event)"
				></nz-pagination>
				<br />
			</div>

			@if (users().length > 0) {
				<app-list
					[enableSelect]="true"
					[items]="users()"
					[isLeaf]="true"
					[selectedUuid]="(adminService.selectedUser$ | async)?.uuid"
					prefix="USER"
					(onSelect)="select($event)"
				>
					<ng-template let-item>
						<div class="fade-in-with-delay">
							{{ displayNames()[item.uuid] || item.email || item.uuid }}
						</div>
					</ng-template>
				</app-list>
			}
		</div>
	</div>
}
